export default (anchorId) => {
  const anchor = document.querySelector(anchorId);

  if (anchor) {
    const widget = document.querySelector('.pmweb_widget');
    const scroll = document.querySelector('.preview > .scroll-area');
    const offset = widget ? widget.offsetHeight : 0;

    (scroll || window).scrollTo({
      top: anchor.offsetTop - offset,
      behavior: 'smooth',
    });
  }
};
